require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-closures-the-ringers-of-javascript.json") })
        }
      }, "path---blog-closures-the-ringers-of-javascript");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-closures-the-ringers-of-javascript!./.cache/json/blog-closures-the-ringers-of-javascript.json
// module id = 757
// module chunks = 231608221292675